// Silent token renewal lands here inside a hidden iframe that react-oidc-context
// creates. The AuthProvider wrapper in this page's render tree automatically
// calls userManager.signinSilentCallback() when it detects this page is the
// configured silent_redirect_uri — no explicit action needed here.
export function SilentRenewPage() {
    return null;
}
